'use strict';

import { scaleBgSprite } from "./scaler";

var SceneAnimation = new Phaser.Class({

  Extends: Phaser.Scene,

  initialize:

  function SceneAnimation ()
  {
    Phaser.Scene.call(this, { key: 'sceneAnimation', active: false });
  },

  init: function(params){
    var self = this;
    this.params = params;

    this.sceneBoot = this.scene.get('sceneBoot');
    this.scaler = this.sceneBoot.scaler;

    // this.sceneBoot.scaleMode = 'height';
    // this.scaler.scaleMode = 'height';

    this.sceneBoot.windowResized = true;
    
    this.scene.bringToTop();

    this.frame = 0;
  },

  preload: function ()
  {

  },

  create: function ()
  {
    var self = this;
    var sprite, designX, designY;

    designX = 447;
    designY = 790;
    sprite = this.add.image(
      this.scaler.scaleBgX(designX, 'center'),
      this.scaler.scaleY(designY),
      'start',
      0
    );
    sprite.setOrigin(0.5, 0.5);
    this.scaler.scaleSprite(sprite);
    sprite.keepData = {
      resized: true,
      designX: designX,
      designY: designY,
      xlocation: 'left',
      scale: 0.75,
      scaleX: -1,
    };
    this.animationSprite = sprite;
    sprite.scale *= 0.75;
    sprite.scaleX *= -1;

    // this.circleAnimation();

    this.hide();
  },

  update: function() {
  },

  resized: function () {
    var phaserElements = this.children.list;
    for(var i = 0; i < phaserElements.length; i ++){
      var s = phaserElements[i];
      if(s.keepData && s.keepData.resized == true){
        if(s.type == 'Video'){
          s.x = this.scaler.scaleX(this.scaler.designRefWidth()/2);
          s.y = this.scaler.scaleY(this.scaler.designRefHeight()/2);
          this.scaler.scaleSpriteByMax(s);
        } else{
          if(s.keepData.xlocation && s.keepData.xlocation == 'center'){
            s.x = this.scaler.scaleBgX(s.keepData.designX, 'center');
          } else if(s.keepData.xlocation && s.keepData.xlocation == 'right'){
            s.x = this.scaler.scaleBgX(s.keepData.designX, 'right');
          } else{
            s.x = this.scaler.scaleBgX(s.keepData.designX);
          }

          if(s.keepData.ylocation && s.keepData.ylocation == 'bottom'){
            s.y = this.scaler.scaleY(this.scaler.designRefHeight() + s.keepData.designY);
          } else if(s.keepData.ylocation && s.keepData.ylocation == 'center'){
            s.y = this.scaler.scaleY(this.scaler.designRefHeight()/2 + s.keepData.designY);
          } else{
            s.y = this.scaler.scaleY(s.keepData.designY);
          }
          
          if(s.keepData.fill){
            this.scaler.scaleSpriteFill(s);
          } else{
            this.scaler.scaleSprite(s);
          }

          if(s.keepData.displayWidth){
            s.displayWidth = s.keepData.displayWidth * this.scaler.hScale();
          }

          if(s.keepData.scale){
            s.scale *= s.keepData.scale;
          }

          if(s.keepData.scaleX){
            s.scaleX *= s.keepData.scaleX;
          }
        }
      }
    }
  },

  setFrame: function() {
    if(this.animationSprite.visible == false) {
      return;
    }
    var totalFrame = 180;

    this.frame ++;
        
    if(this.frame > totalFrame - 1){
      this.frame = 0;
    }
    
    this.animationSprite.setFrame(this.frame);
  },

  circleAnimation: function(){
    var totalFrame = 180;
    
    this.stopAnimation();

    this.circleAnimationTimer = this.time.addEvent({
      delay: 1000/25,
      callback: function(){
        this.frame ++;
        
        if(this.frame > totalFrame - 1){
          this.frame = 0;
        }
        
        this.animationSprite.setFrame(this.frame);
      },
      callbackScope: this,
      loop: true
    });

  },

  stopAnimation: function() {
    if(this.circleAnimationTimer) {
      this.circleAnimationTimer.destroy();
    }
  },

  enterAnimation: function(delay, duration) {
    var self = this;
    this.tweens.add({
      targets: this.animationSprite,
      alpha: {
        start: 0.001,
        to: 1
      },
      duration: duration,
      delay: delay,
      ease: 'Linear',
      repeat: 0,
      yoyo: false,
      onComplete: function () {
      },
    }); 
  },

  fadeoutAnimation: function() {
    var self = this;

    var duration = GC.animationDuration;
    this.tweens.add({
      targets: this.animationSprite,
      alpha: 0.001,
      duration: duration,
      delay: 0,
      ease: 'Linear',
      repeat: 0,
      yoyo: false,
      onComplete: function () {
      },
    }); 
  },

  show: function() {
    this.animationSprite.visible = true;
  },

  hide: function(){
    this.animationSprite.visible = false;
  },

});
export default SceneAnimation;